import {
  Handshake,
  Users,
  Package,
  Tag,
  Gift,
  Server,
  TrendingUp,
  Zap,
} from 'lucide-react';
import { PartnershipStats } from '../../types/partnership';
import { StatTile } from '../ui/StatTile';

interface PartnershipStatsCardsProps {
  stats: PartnershipStats | null;
}

type Tone = 'neutral' | 'accent' | 'purple' | 'success' | 'warning' | 'amber' | 'orange' | 'danger' | 'info';

export const PartnershipStatsCards = ({ stats }: PartnershipStatsCardsProps) => {
  if (!stats) return null;

  const cards: { label: string; value: number; icon: typeof Handshake; tone: Tone }[] = [
    { label: 'Total Partnerships', value: stats.total, icon: Handshake, tone: 'accent' },
    { label: 'Active', value: stats.by_status?.active || 0, icon: Zap, tone: 'success' },
    { label: 'Creators', value: stats.total_creators, icon: Users, tone: 'info' },
    { label: 'Modpacks', value: stats.total_modpacks, icon: Package, tone: 'purple' },
    { label: 'Active Codes', value: stats.total_active_codes, icon: Tag, tone: 'accent' },
    { label: 'Incentives', value: stats.total_active_incentives, icon: Gift, tone: 'amber' },
    { label: 'Server Links', value: stats.total_server_links, icon: Server, tone: 'success' },
    { label: 'Recently Active', value: stats.recently_active, icon: TrendingUp, tone: 'orange' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {cards.map((card) => (
        <StatTile
          key={card.label}
          label={card.label}
          value={(card.value ?? 0).toLocaleString()}
          icon={card.icon}
          tone={card.tone}
        />
      ))}
    </div>
  );
};
